(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-newsletter"] && !Shopify.designMode) return;
  try {
    
  class PopupNewsletterModal extends HTMLElement {
    connectedCallback() {
      this.storageKey = this.dataset.storageKey || 'rifim_newsletter_popup';
      this.delay = (parseFloat(this.dataset.delay) || 3) * 1000;
      this.reappearDays = parseFloat(this.dataset.reappearDays) || 30;

      this.overlay = this.querySelector('[data-popup-overlay]');
      this.dialog = this.querySelector('[data-popup-dialog]');
      this.form = this.querySelector('form');
      this.copyButton = this.querySelector('[data-copy-code]');
      this.promoCodeEl = this.querySelector('[data-promo-code]');
      this.formStep = this.querySelector('[data-step="form"]');
      this.successStep = this.querySelector('[data-step="success"]');
      this.errorEl = this.querySelector('[data-form-error]');

      this._boundKeydown = this.#handleKeydown.bind(this);

      if (!this.#shouldShow()) return;

      this.querySelectorAll('[data-popup-close], [data-popup-dismiss]').forEach((btn) => {
        btn.addEventListener('click', () => this.close('dismissed'));
      });
      this.overlay.addEventListener('click', () => this.close('dismissed'));
      this.dialog.addEventListener('click', (event) => event.stopPropagation());

      if (this.form) {
        this.form.addEventListener('submit', this.#handleSubmit.bind(this));
      }
      if (this.copyButton) {
        this.copyButton.addEventListener('click', this.#handleCopy.bind(this));
      }

      this._timer = setTimeout(() => this.open(), this.delay);
    }

    disconnectedCallback() {
      clearTimeout(this._timer);
      document.removeEventListener('keydown', this._boundKeydown);
    }

    #shouldShow() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        if (!raw) return true;
        const data = JSON.parse(raw);
        if (data.state === 'subscribed') return false;
        if (data.state === 'dismissed') {
          const elapsedDays = (Date.now() - data.ts) / 86400000;
          if (elapsedDays < this.reappearDays) return false;
        }
        return true;
      } catch (error) {
        return true;
      }
    }

    #remember(state) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify({ state, ts: Date.now() }));
      } catch (error) {
        /* localStorage unavailable (private mode, quota, etc.) — fail silently */
      }
    }

    open() {
      this.hidden = false;
      document.addEventListener('keydown', this._boundKeydown);
      document.body.style.overflow = 'hidden';
      // Force a reflow so the browser commits the "closed" state before the
      // class below triggers the CSS transition. Using this instead of
      // requestAnimationFrame keeps the open animation reliable even in
      // backgrounded/inactive tabs, where rAF callbacks are paused.
      void this.offsetHeight;
      this.classList.add('is-open');
      this.dialog.focus();
    }

    close(reason) {
      this.classList.remove('is-open');
      document.removeEventListener('keydown', this._boundKeydown);
      document.body.style.overflow = '';
      if (reason === 'dismissed') this.#remember('dismissed');
      setTimeout(() => {
        this.hidden = true;
      }, 250);
    }

    #handleKeydown(event) {
      if (event.key === 'Escape') {
        this.close('dismissed');
        return;
      }
      if (event.key === 'Tab') {
        this.#trapFocus(event);
      }
    }

    #trapFocus(event) {
      const focusable = this.dialog.querySelectorAll(
        'button:not([hidden]), [href], input:not([hidden]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    async #handleSubmit(event) {
      event.preventDefault();
      const submitButton = this.form.querySelector('[type="submit"]');
      const emailInput = this.form.querySelector('input[type="email"]');

      if (this.errorEl) this.errorEl.hidden = true;

      if (!emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      if (submitButton) submitButton.disabled = true;

      try {
        const response = await fetch(this.form.action, {
          method: this.form.method || 'POST',
          body: new FormData(this.form),
        });
        if (!response.ok) {
          throw new Error('Newsletter signup request failed with status ' + response.status);
        }
        this.#remember('subscribed');
        this.formStep.hidden = true;
        this.successStep.hidden = false;
        const successHeading = this.successStep.querySelector('h2');
        if (successHeading) successHeading.focus();
      } catch (error) {
        if (this.errorEl) this.errorEl.hidden = false;
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    }

    #handleCopy() {
      const code = this.promoCodeEl.textContent.trim();
      const button = this.copyButton;
      const original = button.textContent;
      const done = () => {
        button.textContent = 'Copie !';
        setTimeout(() => {
          button.textContent = original;
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        done();
      }
    }
  }

  if (!customElements.get('popup-newsletter-modal')) {
    customElements.define('popup-newsletter-modal', PopupNewsletterModal);
  }

  } catch(e) { console.error(e); }
})();
})();
